import gql from 'graphql-tag';

export const NUCLEUS_SCREENHUB_SUBSCRIPTION = gql`
  subscription screenhubSubscription($playerId: String!) {
    screenhubSubscription(playerId: $playerId) {
      playerId
      requestId
      topic
      payload
      error {
        code
        message
      }
    }
  }
`;